import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

/**
 * @typedef {object} Props
 * @property {(payload: { to: string }) => void} redirect
 */

/**
 * @template {object} P
 * @param {React.ComponentType<P>} WrappedComponent
 * @returns {Component<P & Props>}
 */
function withRedirect(WrappedComponent) {
  class WithRedirect extends Component {
    static displayName = `WithRedirect(${WrappedComponent.displayName || WrappedComponent.name})`

    /** @type {(payload: { to: string }) => void} */
    redirect = ({ to, ...other }) => {
      this.props.history.push(to, other)
    }

    render = () => {
      const { history, location, match, staticContext, ...otherProps } = this.props
      return <WrappedComponent { ...otherProps } redirect={ this.redirect } />
    }
  }

  return withRouter(WithRedirect)
}

export default withRedirect



// WEBPACK FOOTER //
// ./src/pages/report/billing-plan/hocs/withRedirect.js